import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::index
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/api/admin/session-templates',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::index
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::index
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::index
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::store
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/admin/session-templates',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::store
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::store
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::show
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
export const show = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/api/admin/session-templates/{sessionTemplate}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::show
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
show.url = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sessionTemplate: args }
    }

    if (Array.isArray(args)) {
        args = {
            sessionTemplate: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sessionTemplate: args.sessionTemplate,
    }

    return show.definition.url
            .replace('{sessionTemplate}', parsedArgs.sessionTemplate.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::show
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
show.get = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::show
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
show.head = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::update
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
export const update = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/admin/session-templates/{sessionTemplate}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::update
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
update.url = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sessionTemplate: args }
    }

    if (Array.isArray(args)) {
        args = {
            sessionTemplate: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sessionTemplate: args.sessionTemplate,
    }

    return update.definition.url
            .replace('{sessionTemplate}', parsedArgs.sessionTemplate.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::update
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
update.put = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::destroy
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
export const destroy = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/api/admin/session-templates/{sessionTemplate}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::destroy
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
destroy.url = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sessionTemplate: args }
    }

    if (Array.isArray(args)) {
        args = {
            sessionTemplate: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sessionTemplate: args.sessionTemplate,
    }

    return destroy.definition.url
            .replace('{sessionTemplate}', parsedArgs.sessionTemplate.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::destroy
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}'
*/
destroy.delete = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::copy
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}/copy'
*/
export const copy = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: copy.url(args, options),
    method: 'post',
})

copy.definition = {
    methods: ["post"],
    url: '/api/admin/session-templates/{sessionTemplate}/copy',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::copy
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}/copy'
*/
copy.url = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sessionTemplate: args }
    }

    if (Array.isArray(args)) {
        args = {
            sessionTemplate: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sessionTemplate: args.sessionTemplate,
    }

    return copy.definition.url
            .replace('{sessionTemplate}', parsedArgs.sessionTemplate.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SessionTemplateController::copy
* @see app/Http/Controllers/Admin/SessionTemplateController.php:0
* @route '/api/admin/session-templates/{sessionTemplate}/copy'
*/
copy.post = (args: { sessionTemplate: string | number } | [sessionTemplate: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: copy.url(args, options),
    method: 'post',
})

const sessionTemplates = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    copy: Object.assign(copy, copy),
}

export default sessionTemplates